import { Location } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { MatDialog } from "@angular/material/dialog";
import { filter, switchMap, takeUntil } from "rxjs/operators";
import { SettingsService } from 'src/app/services/settings.service';
import { ChangeShipWarehouseAddressComponent } from '../change-ship-warehouse-address/change-ship-warehouse-address.component';
import { NotePopupComponent } from '../note-popup/note-popup.component';
import { AuthService } from 'src/app/services/auth.service';
import { LoginModel } from 'src/app/models/login.model';
import { RelatedShipmentPopupComponent } from 'src/app/modules/shipyard/related-shipment-popup/related-shipment-popup.component';
import { HeaderService } from '../header/header.service';
import { SnackbarComponent } from '../snackbar/snackbar.component'
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmDialogComponent } from '../dialogs/confirm-dialog/confirm-dialog.component';
import { ShipyardService } from 'src/app/modules/shipyard/shipyard.service';
import { ItemPickingService } from 'src/app/modules/items-picking/item-picking.service';
import { MappedItemPopupComponent } from '../mapped-item-popup/mapped-item-popup.component';
@Component({
  selector: 'app-shipment-info-bar',
  templateUrl: './shipment-info-bar.component.html',
  styleUrls: ['./shipment-info-bar.component.scss']
})
export class ShipmentInfoBarComponent implements OnInit, OnDestroy {
  information='Shipment Information';
  name=new FormControl('Shipment Information');
  @Input() shipmentDetail:any;
  @Input() accountType;
  @Input() cubicFeet:number;
  edit:boolean=false;
  shipmentDetailForm:FormGroup = this.fb.group({
    logoBase64: [''],
    logoExtension: [''],
    fileName: [''],
    attachmentPath1:[""],
    type:['']
    });
    @ViewChild('attachmentPath1') attachmentPath1;
    base64: string;
  isShow:boolean=false;
  @Output() showInfo: EventEmitter<boolean> = new EventEmitter();  
  @Output() refreshShipment: EventEmitter<boolean> = new EventEmitter();
  private destroy$ = new Subject<void>();
  warehouse: any[];
  deductFromWarehouse: any[];
  userInfo:LoginModel;
  skusNotMapped:any[]=[]

  constructor(private location:Location,
    private dialog: MatDialog,
    private settingService: SettingsService,
    private authService:AuthService,
    public headerService:HeaderService,
    private shipyardService: ShipyardService,
    private snackBar : MatSnackBar,
    private fb: FormBuilder,
    private itemPickingService:ItemPickingService
    ){
      this.authService.userInfo$
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: LoginModel) => {
        this.userInfo = res;
      });
    }

  ngOnInit(): void {
    this.getWarehouseList();
    this.shipmentSkuNotMapped();
  }

  goBack(){
    this.location.back();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  toggleInfo(){
    this.isShow=!this.isShow;
    this.showInfo.emit(true);
  }

  getWarehouseList() {
     this.settingService
      .GetAllWarehouses().pipe(takeUntil(this.destroy$)).subscribe((result: any[]) => {
      this.warehouse = result;
      this.deductFromWarehouse = result.filter((res) => res.isCarriesInventory);
    });
  }

  editWarehouse(isShipmentName = false, deductFrom = false,isShipingPrice=false){
    const dialog = this.dialog.open(ChangeShipWarehouseAddressComponent, {
      width: "500px",
      data: {
        title: isShipmentName ? 'Update Shipment Name' : isShipingPrice ? 'Update Shipping Price' : 'Update Warehouse',
        shipmentHeaderId: this.shipmentDetail.shipmentHeaderId,
        warehouse: !deductFrom ? this.warehouse : this.deductFromWarehouse,
        isShipmentName: isShipmentName,
        isdeductFrom: deductFrom,
        isShipingPrice:isShipingPrice,
        shipingPrice:this.shipmentDetail.shipingPrice,
        shipmentName: this.shipmentDetail.shipmentName ? this.shipmentDetail.shipmentName : this.shipmentDetail.status + ":" + this.shipmentDetail.shipmentHeaderId   
      },
    });
    dialog
      .afterClosed()
      .pipe(filter((e) => e === "Confirm"))
      .subscribe((e) => {
        this.refreshShipment.emit(true);
      }
  );
  }

  boxContentSource(boxContent){
    const dialog = this.dialog.open(ChangeShipWarehouseAddressComponent, {
      width: "500px",
      data: {
        title: 'Box Content Source', 
        boxContentSource:boxContent,
        isShowBoxSource : true,
        shipmentHeaderId: this.shipmentDetail.shipmentHeaderId, 
      },
    });
    dialog
      .afterClosed()
      .subscribe((e) => {
        if(e === "Confirm") this.refreshShipment.emit();
      }
    );
  }

  openNotePopup() {
    const dialog = this.dialog.open(NotePopupComponent, {
      width: "500px",
      data: {
        userNote: this.shipmentDetail?.userNote,
        shipmentHeaderId: this.shipmentDetail?.shipmentHeaderId,
      }
    });
    dialog
      .afterClosed()
      .subscribe((e) => {
        if (e === "Confirm")
          this.refreshShipment.emit();
      });
  }

  getRelatedShipments(e:MouseEvent){
    const dialog = this.dialog.open(RelatedShipmentPopupComponent, {
      width: "390px",
      position:this.getDialogPosition(e),
      data: {
        shipmentId: this.shipmentDetail.amazonShipmentId
      },
    });
    dialog
      .afterClosed()
      .subscribe((e) => {});   
  }

  getDialogPosition(e: MouseEvent) {
    const target = e.target as any;
    const targetPosision = target.getBoundingClientRect();
    return {
      left: targetPosision.right - 145 + "px",
      top: targetPosision.top + 20 + "px",
    }
  }
  
  onFileUpload(event){
    if(this.shipmentDetail.shipmentAttachements?.length < 3){
      if (event.target.files?.length) {
        const fileSizeInKB = Math.round(event.target.files[0].size / 1024);
        this.shipmentDetailForm.controls.logoExtension.setValue(event.target.files[0].name.split(".").pop());
        this.shipmentDetailForm.controls.fileName.setValue(event.target.files[0].name);
        this.shipmentDetailForm.controls.type.setValue(event.target.files[0].type);
        const [file] = event.target.files;
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => {
            if (reader.result) {
              this.base64 = reader.result.toString().split(',')[1]
              this.shipmentDetailForm.controls.logoBase64.setValue(this.base64);
              this.saveShipmentAttachment(event.target.files[0].name);
            }
          }
        }
      } else {
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: "Operation unsuccessful, Please try again.",
              action: 'Dismiss',
              type: 'error',
            },
          }
        )
      }
  }

  openFile(file?) {
    let url: any
    let fileName: any
    this.shipmentDetail?.shipmentAttachements.filter((ele) => {
      if (ele.fileName === file) {
        url = ele.attachmentPath;
        fileName = ele.fileName
      }
    })
    if (url && fileName) {
      window.open(url, '_blank');
    }
  }

  removeAttachmentFile(fileName?){
    let shipmentAttachementId: any;
    this.shipmentDetail.shipmentAttachements.filter((res) => {
      if (res.fileName == fileName) {
        shipmentAttachementId = res.shipmentAttachementId;
      }
    })
    const payload = {
      shipmentAttachementId: shipmentAttachementId,
      type:this.accountType == 'Walmart' ? 'Walmart' : 'Amazon'
    }
    this.dialog
    .open(ConfirmDialogComponent, {
      width: "600px",
      data: {
        title: "Remove File",
        message: "Are you sure you want to remove this File?",
      },
    })
    .afterClosed()
    .pipe(
    filter((result) => result === "Confirm"),
    switchMap(() => this.shipyardService.deleteShipmentAttachment(payload)),
    takeUntil(this.destroy$)
  )
  .subscribe({
    next: (response) => {
          const index = this.shipmentDetail.shipmentAttachements.findIndex((ele) => ele.shipmentAttachementId === shipmentAttachementId);
          if (index !== -1) {
          this.shipmentDetail.shipmentAttachements.splice(index, 1);
          }
          this.snackBar.openFromComponent(SnackbarComponent, {
            duration: 3000,
            horizontalPosition: "center",
            data: {
              title: "Shipment Attachment has been deleted successfully.",
              action: "Dismiss",
              type: "success",
            },
      });
    },
    error: (error) => {
        this.snackBar.openFromComponent(SnackbarComponent, {
            duration: 4000,
            horizontalPosition: 'center',
            data: {
              title: error.error.error,
              action: 'Dismiss',
              type: 'error',
            },
          });
    }
  });
}
  

  saveShipmentAttachment(fileName?) {
    const payload = {
      shipmentHeaderId: this.shipmentDetail.shipmentHeaderId,
      logoBase64: this.shipmentDetailForm.value.logoBase64,
      logoExtension: this.shipmentDetailForm.value.logoExtension,
      fileName: this.shipmentDetailForm.value.fileName,
      type:this.accountType == 'Walmart' ? 'Walmart' : 'Amazon'
    }
    this.shipyardService.saveShipmentAttachment(payload).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res:any) => {
     if(res){
      this.shipmentDetail.shipmentAttachements.push({fileName:res.fileName,attachmentPath : res.attachmentPath, shipmentAttachementId: res.shipmentAttachementId,type:this.shipmentDetailForm.value.type })
    }
      this.snackBar.openFromComponent(SnackbarComponent, {
        duration: 3000,
        horizontalPosition: "center",
        data: {
          title: 'Changes Saved Successfully',
          action: "Dismiss",
          type: "success",
        },
      });
    },
     error: (err) => {
        this.snackBar.openFromComponent(SnackbarComponent, {
          duration: 3000,
          horizontalPosition: "center",
          data: {
            title: err.error.error,
            action: "Dismiss",
            type: "error",
          },
        });
       }
   });
  }

  shipmentSkuNotMapped(){
    this.itemPickingService.shipmentSkuNotMapped(this.shipmentDetail.shipmentHeaderId).subscribe({
      next:(response:any)=>{
        this.skusNotMapped=response
      }, error:(err)=>{
        this.snackBar.openFromComponent(SnackbarComponent, {
          duration: 3000,
          horizontalPosition: "center",
          data: {
            title: "Something went wrong",
            action: "Dismiss",
            type: "error",
          },
        });
      }
    })
  }

  openDialogForSkus(){
    const dialog = this.dialog.open(MappedItemPopupComponent, {
      width: "621px",
      data: {
        title:  "Items Out Of Stock",
        skusNotMapped: this.skusNotMapped,
      },
    });
    dialog
      .afterClosed()
      .pipe(filter((e) => e === "Confirm"))
      .subscribe((e) => {
      }
    ); 
  }

}
